// extracted by mini-css-extract-plugin
export default {"comment_box":"index_comment_box_Medpn","username":"index_username_AcGYP","content_txt":"index_content_txt_ViJJd"};